'use client';

import React from 'react';

const ClientSideDescription: React.FC<{ description: string }> = ({ description }) => {
  return <p className="land-based-banner-info" dangerouslySetInnerHTML={{ __html: description }} />;
};

export default ClientSideDescription;
